import React from 'react';
import { Target, Compass, Zap, Shield, ArrowRight, Rocket, Sparkles, HandHeart } from 'lucide-react';
import { DarkCard, LightCard, CheckListItem } from '../components/Cards';
export function Coaching1la1() {
  return <div className="bg-rise-white min-h-screen" data-id="element-335">
      {/* 1. Hero Section */}
      <section className="bg-rise-black text-rise-white py-12 md:py-20 px-6 relative overflow-hidden" data-id="element-336">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-337">
          <div className="absolute top-[-20%] right-[-10%] w-[50%] h-[100%] bg-rise-gold/5 blur-[120px] rounded-full" data-id="element-338"></div>
        </div>
        <div className="max-w-rise-content mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center relative z-10" data-id="element-339">
          {/* Text Content */}
          <div className="flex flex-col items-center text-center order-1" data-id="element-340">
            <div className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-white border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-341">
              TRANSFORMARE PROFUNDĂ
            </div>
            <h1 className="font-playfair text-[36px] md:text-[52px] leading-tight mb-6" data-id="element-342">
              Coaching 1 la 1
            </h1>

            {/* Photo on mobile only */}
            <div className="lg:hidden relative mb-8 w-full max-w-[280px] mx-auto" data-id="element-343">
              <div className="absolute inset-0 border border-rise-gold/70 rounded-xl translate-x-3 translate-y-3 pointer-events-none" data-id="element-344"></div>
              <img src="https://cdn.magicpatterns.com/uploads/iUcBmPMC4srAe2sezJvkST/Teodora_3.jpg" alt="Teodora Trifu" className="w-full h-auto aspect-[4/5] object-cover rounded-xl shadow-lg relative z-10" data-id="element-345" />
            </div>

            <p className="font-dm-sans text-[19px] text-rise-white/80 max-w-xl mx-auto leading-relaxed mb-10" data-id="element-346">
              Ghidare personalizată, adaptată nevoilor tale specifice. Un spațiu
              confidențial în care lucrăm împreună pentru a depăși blocajele și
              a construi viața pe care ți-o dorești cu adevărat.
            </p>
            <div className="flex justify-center w-full" data-id="element-347">
              <a href="#pachete" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[16px] transition-colors flex items-center justify-center gap-2 w-full max-w-md" data-id="element-348">
                Aplică pentru Sesiunea Cadou <ArrowRight size={18} data-id="element-349" />
              </a>
            </div>
          </div>

          {/* Photo on desktop only */}
          <div className="relative hidden lg:block w-full max-w-md mx-auto lg:ml-auto order-2" data-id="element-350">
            <div className="absolute inset-0 border border-rise-gold/70 rounded-xl translate-x-5 translate-y-5 pointer-events-none" data-id="element-351"></div>
            <img src="https://cdn.magicpatterns.com/uploads/iUcBmPMC4srAe2sezJvkST/Teodora_3.jpg" alt="Teodora Trifu" className="w-full h-auto aspect-[4/5] object-cover rounded-xl shadow-lg relative z-10" data-id="element-352" />
          </div>
        </div>
      </section>

      {/* 2. Ce este coaching-ul 1:1 */}
      <section className="py-12 md:py-20 px-6 bg-rise-white" data-id="element-353">
        <div className="max-w-rise-content mx-auto" data-id="element-354">
          <div className="max-w-3xl mx-auto text-center" data-id="element-355">
            <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-black text-center mb-6" data-id="element-356">
              Un parteneriat pentru evoluția ta
            </h2>
            <p className="font-dm-sans text-[19px] text-rise-gray leading-relaxed mb-6" data-id="element-357">
              Coaching-ul 1 la 1 nu este despre a primi sfaturi sau rețete
              universale. Este un proces profund de auto-descoperire în care eu
              acționez ca o oglindă clară și un ghid obiectiv.
            </p>
            <p className="font-dm-sans text-[19px] text-rise-gray leading-relaxed" data-id="element-358">
              Împreună, explorăm unghiurile moarte, identificăm tiparele care te
              țin pe loc și construim strategii personalizate pentru a ajunge de
              unde ești acum, acolo unde îți dorești să fii. Este cea mai rapidă
              și eficientă formă de transformare personală.
            </p>
          </div>
        </div>
      </section>

      {/* 3. Pentru cine este */}
      <section className="py-12 md:py-20 px-6 bg-rise-anthracite text-rise-white" data-id="element-359">
        <div className="max-w-rise-content mx-auto" data-id="element-360">
          <div className="text-center mb-16" data-id="element-361">
            <h2 className="font-playfair text-[32px] md:text-[42px] mb-4" data-id="element-362">
              Acest proces este pentru tine dacă:
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-363">
            <DarkCard title="Ești pregătit pentru acțiune" watermark="A" icon={<Rocket size={28} strokeWidth={1.5} data-id="element-365" />} data-id="element-364">
              Ai obosit să doar citești cărți de dezvoltare personală și vrei să
              treci la implementare practică în viața ta.
            </DarkCard>
            <DarkCard title="Cauți claritate" watermark="C" icon={<Compass size={28} strokeWidth={1.5} data-id="element-367" />} data-id="element-366">
              Te afli la o răscruce de drumuri (carieră, relații, sensul vieții)
              și ai nevoie de o perspectivă obiectivă pentru a lua cea mai bună
              decizie.
            </DarkCard>
            <DarkCard title="Vrei rezultate specifice" watermark="R" icon={<Target size={28} strokeWidth={1.5} data-id="element-369" />} data-id="element-368">
              Ai un obiectiv clar, dar simți că te sabotezi singur sau că ceva
              invizibil te trage înapoi de fiecare dată când ești aproape de
              reușită.
            </DarkCard>
            <DarkCard title="Îți asumi responsabilitatea" watermark="R" icon={<HandHeart size={28} strokeWidth={1.5} data-id="element-371" />} data-id="element-370">
              Înțelegi că eu te pot ghida și susține, dar munca și deciziile îți
              aparțin în totalitate.
            </DarkCard>
          </div>
        </div>
      </section>

      {/* 4. Arii de lucru */}
      <section className="py-12 md:py-20 px-6 bg-rise-white" data-id="element-372">
        <div className="max-w-rise-content mx-auto" data-id="element-373">
          <div className="text-center mb-16" data-id="element-374">
            <div className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-black border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-375">
              CUM TE POT AJUTA
            </div>
            <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-black mb-4" data-id="element-376">
              Arii principale de lucru
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-377">
            <LightCard title="Încredere în Sine" data-id="element-378">
              <p data-id="element-379">
                Depășirea sindromului impostorului, reconstruirea stimei de sine
                și curajul de a te exprima autentic.
              </p>
            </LightCard>
            <LightCard title="Relații & Limite" data-id="element-380">
              <p data-id="element-381">
                Vindecarea tiparelor toxice, setarea limitelor sănătoase și
                construirea unor relații bazate pe respect reciproc.
              </p>
            </LightCard>
            <LightCard title="Carieră & Sens" data-id="element-382">
              <p data-id="element-383">
                Găsirea vocației, tranziții profesionale, depășirea blocajelor
                financiare și alinierea muncii cu valorile tale.
              </p>
            </LightCard>
            <LightCard title="Echilibru Emoțional" data-id="element-384">
              <p data-id="element-385">
                Gestionarea stresului, a anxietății și a burnout-ului. Crearea
                unui stil de viață sustenabil și echilibrat.
              </p>
            </LightCard>
          </div>
        </div>
      </section>

      {/* 5. Metodologia mea (Dark) */}
      <section className="py-12 md:py-20 px-6 bg-rise-anthracite text-rise-white" data-id="element-386">
        <div className="max-w-rise-content mx-auto" data-id="element-387">
          <div className="text-center mb-16" data-id="element-388">
            <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-white mb-4" data-id="element-389">
              Abordarea R.I.S.E. în Coaching
            </h2>
            <p className="font-dm-sans text-[19px] text-rise-white/70 max-w-2xl mx-auto" data-id="element-390">
              Folosesc o abordare holistică, integrând tehnici de coaching
              cognitiv-comportamental, mindfulness și somatică.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-391">
            <div className="text-center" data-id="element-392">
              <Target className="text-rise-gold mx-auto mb-6" size={40} data-id="element-393" />
              <h3 className="font-playfair text-[22px] text-rise-white mb-3" data-id="element-394">
                Claritate Mentală
              </h3>
              <p className="font-dm-sans text-[16px] text-rise-white/70" data-id="element-395">
                Identificăm și restructurăm credințele limitative și tiparele de
                gândire care te sabotează.
              </p>
            </div>
            <div className="text-center" data-id="element-396">
              <Shield className="text-rise-gold mx-auto mb-6" size={40} data-id="element-397" />
              <h3 className="font-playfair text-[22px] text-rise-white mb-3" data-id="element-398">
                Siguranță Emoțională
              </h3>
              <p className="font-dm-sans text-[16px] text-rise-white/70" data-id="element-399">
                Creăm un spațiu sigur pentru procesarea emoțiilor blocate și
                reglarea sistemului nervos.
              </p>
            </div>
            <div className="text-center" data-id="element-400">
              <Zap className="text-rise-gold mx-auto mb-6" size={40} data-id="element-401" />
              <h3 className="font-playfair text-[22px] text-rise-white mb-3" data-id="element-402">
                Acțiune Strategică
              </h3>
              <p className="font-dm-sans text-[16px] text-rise-white/70" data-id="element-403">
                Traducem conștientizările în pași practici, măsurabili, pentru a
                obține rezultate tangibile.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 6. Cum se desfasoara (Light) - vertical timeline */}
      <section className="py-12 md:py-20 px-6 bg-rise-white text-rise-black" data-id="element-404">
        <div className="max-w-rise-content mx-auto" data-id="element-405">
          <div className="max-w-3xl mx-auto" data-id="element-406">
            <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-black text-center mb-16" data-id="element-407">
              Cum se desfășoară procesul?
            </h2>

            {/* Timeline */}
            <div className="relative" data-id="element-408">
              {/* Vertical connecting line */}
              <div className="absolute left-5 md:left-6 top-2 bottom-2 w-px bg-rise-gold/40" aria-hidden="true" data-id="element-409"></div>

              <ol className="space-y-6" data-id="element-410">
                {/* Step 1 */}
                <li className="relative pl-16 md:pl-20" data-id="element-411">
                  <div className="absolute left-0 top-0 shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full bg-rise-white border-2 border-rise-gold text-rise-gold flex items-center justify-center font-playfair font-bold text-[18px] md:text-[20px] z-10" data-id="element-412">
                    1
                  </div>
                  <div className="bg-white border border-rise-gold/30 rounded-xl p-6 md:p-8 shadow-sm relative" data-id="element-413">
                    <div className="absolute top-0 left-0 w-1 h-full bg-rise-gold rounded-l-xl" data-id="element-414"></div>
                    <h4 className="font-playfair text-[20px] md:text-[22px] text-rise-black mb-2" data-id="element-415">
                      Sesiunea de Cunoaștere (Gratuită)
                    </h4>
                    <p className="font-dm-sans text-[16px] text-rise-gray leading-relaxed" data-id="element-416">
                      O discuție de 20 de minute pentru a vedea dacă rezonăm și
                      dacă te pot ajuta cu obiectivul tău.
                    </p>
                  </div>
                </li>

                {/* Step 2 */}
                <li className="relative pl-16 md:pl-20" data-id="element-417">
                  <div className="absolute left-0 top-0 shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full bg-rise-white border-2 border-rise-gold text-rise-gold flex items-center justify-center font-playfair font-bold text-[18px] md:text-[20px] z-10" data-id="element-418">
                    2
                  </div>
                  <div className="bg-white border border-rise-gold/30 rounded-xl p-6 md:p-8 shadow-sm relative" data-id="element-419">
                    <div className="absolute top-0 left-0 w-1 h-full bg-rise-gold rounded-l-xl" data-id="element-420"></div>
                    <h4 className="font-playfair text-[20px] md:text-[22px] text-rise-black mb-2" data-id="element-421">
                      Alegerea Pachetului
                    </h4>
                    <p className="font-dm-sans text-[16px] text-rise-gray leading-relaxed" data-id="element-422">
                      Stabilim împreună frecvența și durata procesului (de
                      obicei sesiuni săptămânale sau la 2 săptămâni).
                    </p>
                  </div>
                </li>

                {/* Step 3 */}
                <li className="relative pl-16 md:pl-20" data-id="element-423">
                  <div className="absolute left-0 top-0 shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full bg-rise-white border-2 border-rise-gold text-rise-gold flex items-center justify-center font-playfair font-bold text-[18px] md:text-[20px] z-10" data-id="element-424">
                    3
                  </div>
                  <div className="bg-white border border-rise-gold/30 rounded-xl p-6 md:p-8 shadow-sm relative" data-id="element-425">
                    <div className="absolute top-0 left-0 w-1 h-full bg-rise-gold rounded-l-xl" data-id="element-426"></div>
                    <h4 className="font-playfair text-[20px] md:text-[22px] text-rise-black mb-2" data-id="element-427">
                      Sesiunile de Coaching
                    </h4>
                    <p className="font-dm-sans text-[16px] text-rise-gray leading-relaxed" data-id="element-428">
                      Întâlniri online de 60 de minute pe Zoom, axate pe
                      obiectivul tău. Între sesiuni vei primi exerciții și teme
                      de reflecție.
                    </p>
                  </div>
                </li>
              </ol>
            </div>

            {/* Confidentialitate card */}
            <div className="bg-white border border-rise-gold/40 p-8 md:p-10 rounded-2xl shadow-sm flex flex-col items-center text-center mt-12" data-id="element-429">
              <Compass className="text-rise-gold mb-6" size={48} data-id="element-430" />
              <h3 className="font-playfair text-[24px] text-rise-black mb-4" data-id="element-431">
                Confidențialitate 100%
              </h3>
              <p className="font-dm-sans text-[16px] text-rise-gray leading-relaxed" data-id="element-432">
                Spațiul nostru de lucru este complet securizat și confidențial.
                Poți aduce în discuție orice temă, știind că ești ascultat cu
                empatie, fără nicio urmă de judecată. Rolul meu este să te
                susțin necondiționat în procesul tău.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 7. Invitație Sesiune Cadou (Dark) */}
      <section id="pachete" className="py-12 md:py-20 px-6 bg-rise-anthracite text-rise-white" data-id="element-433">
        <div className="max-w-rise-content mx-auto" data-id="element-434">
          <div className="max-w-3xl mx-auto bg-rise-black border border-rise-gold/40 rounded-2xl p-8 md:p-12 shadow-xl relative overflow-hidden" data-id="element-435">
            <div className="absolute top-0 left-0 w-full h-1 bg-rise-gold" data-id="element-436"></div>

            <div className="text-center" data-id="element-437">
              <span className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-white border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-438">
                Sesiune Cadou 1:1
              </span>
              <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-white mb-6" data-id="element-439">
                Rezervă-ți Sesiunea Cadou 1 la 1 de Coaching cu mine
              </h2>
              <p className="font-dm-sans text-[19px] text-rise-white/80 leading-relaxed mb-6" data-id="element-440">
                O sesiune de 45 de minute, online, în care lucrăm împreună la
                situația ta concretă. Identificăm blocajul principal, clarificăm
                direcția și plecăm cu un prim pas asumat de făcut.
              </p>
              <p className="font-dm-sans text-[19px] text-rise-white/80 leading-relaxed mb-10" data-id="element-441">
                Fără presiune și fără vânzare. Doar tu, eu și ce ai în tine.
                Dacă după sesiune simți că vrei să continuăm într-un proces mai
                lung, vorbim atunci, pe baza a ceea ce am descoperit împreună.
              </p>

              <div className="flex justify-center" data-id="element-442">
                <a href="https://docs.google.com/forms/d/e/1FAIpQLSfZvTY3b9zlXihtr5N7rytBUsvVV4lTYHjzoiEOGqKUeKSdVw/viewform" target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[16px] transition-colors inline-flex items-center justify-center gap-2" data-id="element-443">
                  Aplică pentru Sesiunea Cadou <ArrowRight size={18} data-id="element-444" />
                </a>
              </div>

              <p className="font-dm-sans italic text-[14px] text-rise-white/60 mt-6" data-id="element-445">
                Locuri limitate. Sesiunile se ocupă în ordinea aplicațiilor.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}